module.exports = __webpack_public_path__ + "assets/icon-attention-filled.3ae6bc49.svg";